import { formatToUSDateTimeWith12Hour } from 'utils/dateTimeUtils/dateFormatUtil';

import UsersGridRowWrapper from 'components/UsersGrid/components/UsersGridRowWrapper';
import GridText from 'components/text/GridText';
import TableLink from 'components/text/TableLink';

import usePageRoutes from 'hooks/usePageRoutes';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const UsersGridRow: FunctionComponent<Props> = ({
    createdAt,
    firstName,
    id,
    lastName,
    ref,
    roles,
    status,
    style,
    testId = TEST_ID
}: Props) => {
    const { userDetailsPage } = usePageRoutes();

    return (
        <UsersGridRowWrapper ref={ref} style={style} testId={testId}>
            <TableLink
                className={styles.tableLink}
                text={`${firstName} ${lastName}`}
                to={userDetailsPage(id)}
            />

            <GridText text={roles.join(', ')} />

            <GridText text={status} />

            <GridText text={formatToUSDateTimeWith12Hour(createdAt)} />
        </UsersGridRowWrapper>
    );
};

export default UsersGridRow;
